import { render, staticRenderFns } from "./addIntegration.vue?vue&type=template&id=841b19e0&scoped=true"
import script from "./addIntegration.vue?vue&type=script&lang=js"
export * from "./addIntegration.vue?vue&type=script&lang=js"
import style0 from "./addIntegration.vue?vue&type=style&index=0&id=841b19e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841b19e0",
  null
  
)

export default component.exports